import React, { useState, useEffect, useCallback } from 'react';
import { Card, Typography, Row, Col, Button, Form, message, Upload, List, Tooltip,Divider,Spin } from 'antd';
import { UploadOutlined, DownloadOutlined,DeleteOutlined, ConsoleSqlOutlined } from '@ant-design/icons'; // For the upload icon
import { BASE_URL } from '../Components/Constant';
import ChildRecordTable from './RecordTable';
import ApiService from '../Components/apiService';
import CreateRecordDrawer from './CreateRecordDrawer';
import CreateRecordModal from './CreateRecordModal';
import { generateBody } from '../Components/Utility';
import Cookies from 'js-cookie';
import FieldHistory from './FieldHistory';
import { useSelector } from "react-redux";


const { Title } = Typography;

const RelatedRecord = ({ objectName, recordId,fields,recordDetails}) => {
  const [groupedData, setGroupedData] = useState({});
  const [childRecordsMap, setChildRecordsMap] = useState({});
  const [fieldsDataMap, setFieldsDataMap] = useState({});
  const [currentChildObjectName, setCurrentChildObjectName] = useState('');
  const [currentFieldsData, setCurrentFieldsData] = useState([]);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const [currentRecordName, setCurrentRecordName] = useState('');
  const [isFieldReadOnly, setIsFieldReadOnly] = useState(false);
  const [files, setFiles] = useState([]);
  const [isAllowFile, setIsAllowFiles] = useState(false);
  const [isTrackFieldHistory, setIsTrackFieldHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recordDetailsToSend,setRecordDetailsToSend] = useState([]);
  const [creationView, setCreationView] = useState(null);
  const [layout, setLayout] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isRelatedCreate,setIsRelatedCreate]=useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize,setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [paginationState, setPaginationState] = useState({});
  const currUserId = Cookies.get('userId');
  const currUserName = Cookies.get('name');
  const [currentRelatedList,setCurrentRelatedList]=useState(null);
  const [activeCurrencies,setActiveCurrencies] = useState([]);
  const userCurrency = Cookies.get('userCurrency');
    const security = useSelector((state) => state.data.items[0]);

  useEffect(() => {

    const fetchallowfile = async (objectName) => {
      try {

        const relatedListService = new ApiService(
          `${BASE_URL}/get_mt_object_by_name/${objectName}`,
          {},
          'GET'
        );
        const response = await relatedListService.makeCall();
        setIsAllowFiles(response[0].allow_files);
        setIsTrackFieldHistory(response[0].track_field_history);
        setCreationView(response[0]?.record_creation_view);

      }
      catch (error) {

      }
    }

      fetchallowfile(objectName);
    

  }, [objectName])
  // Fetch related records
  const fetchRelatedRecords = async () => {
    try {
      setLoading(true); // Start loading

      const relatedListService = new ApiService(
        `${BASE_URL}/related_lists/for_object/${objectName}`,
        {},
        'GET'
      );
      const response = await relatedListService.makeCall();      
      if (Array.isArray(response) && response.length > 0) {
        const grouped = response.reduce((acc, record) => {
          const relatedListName = record.related_list.related_list_name;
          if (!acc[relatedListName]) {
            acc[relatedListName] = [];
          }
          acc[relatedListName].push({
            ...record.related_list,
            child_object_id: record.child_object_id,
            order: record?.related_list?.order,
        });
          setFieldsDataMap((prevMap) => ({
            ...prevMap,
            [record.related_list._id]: record.fields_data || [],
          }));
          return acc;
        }, {});        
        setGroupedData(grouped);
        Object.keys(grouped).forEach((relatedListName) => {
          grouped[relatedListName].forEach((relatedList) => {
            fetchChildRecords(relatedList._id, recordId, relatedListName, 1, pageSize);
          });
        });
      }
      setLoading(false); // Start loading

    } catch (err) {
      console.error('Error fetching related records', err);
      setLoading(false); // Start loading
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelatedRecords();
    fetchCurrentRecordDetails();

  }, [objectName, recordId]);


  const refreshRecords = () => {
    fetchRelatedRecords();
  };
  const handleDeleteChildRecord = useCallback(
    async (childObjectName, childRecordId) => {
      try {
        const apiService = new ApiService(
          `${BASE_URL}/delete_record/${childObjectName}/${childRecordId}`,
          {},
          'DELETE'
        );
        await apiService.makeCall();
        message.success('Record deleted successfully');

        fetchRelatedRecords();
      } catch (error) {
        console.error('Error deleting record:', error);
        message.error('Failed to delete record');
      }
    },
    [fetchRelatedRecords]
  );

  const fetchCurrentRecordDetails = async () => {
    try {
     
      console.log('record details',recordDetails,recordDetails?.Name);
      setCurrentRecordName(recordDetails?.Name || '');
      setRecordDetailsToSend(recordDetails);
    } catch (error) {
      console.error('Error fetching current record details:', error);
    }
  };

  const fetchFieldsForChildObject = async (childObjectName) => {
    try {
      const fieldsService = new ApiService(
        `${BASE_URL}/mt_fields/object/${childObjectName}`,
        {},
        'GET'
      );
      const response = await fieldsService.makeCall();
      const updatedFieldsResponse = response.filter((field) => field.name !== 'recordCount');
      setCurrentFieldsData(updatedFieldsResponse);
  
      try {
        const layouts = new ApiService(
          `${BASE_URL}/get_by_objectName/${childObjectName}`,
          {},
          'GET'
        );
        const res = await layouts.makeCall();
        
        if (res) {
          const activeLayout = res.filter(layout => layout.active);
          setLayout(activeLayout);
        }
      } catch (layoutErr) {
        console.error('Error fetching layout:', layoutErr);
      }
  
      return response ?? [];
      
    } catch (err) {
      console.error('Error fetching fields for child object:', err);
      return [];
    }
  };
  
  const fetchChildRecords = async (relatedListId, recordId, relatedListName, page = 1, size = pageSize) => {
    try {
      setLoading(true);
      const offset = (page - 1) * size;
      const childRecordsService = new ApiService(
        `${BASE_URL}/related_lists/${relatedListId}/${recordId}/child_records?limit=${size}&offset=${offset}`,
        {},
        'GET'
      );
      const response = await childRecordsService.makeCall();
      setChildRecordsMap((prevMap) => ({
        ...prevMap,
        [relatedListId]: response.records || [],
      }));
      setTotalRecords((prevTotal) => ({
        ...prevTotal,
        [relatedListId]: response.total || 0,
      }));
      setPaginationState((prevState) => ({
        ...prevState,
        [relatedListId]: { currentPage: page, pageSize: size },
      }));
    } catch (err) {
      console.error(`Error fetching child records for ${relatedListName}:`, err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCurrency = useCallback(async () => {
    try {
        setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
            'Content-Type': 'application/json',
        }, 'GET');
        const response = await apiService.makeCall();
        console.log('responseresponse:',response);
        setActiveCurrencies(response);
    } catch (err) {
        console.error("Error fetching metadata:", err);
    }finally{
        setLoading(false);
    }
}, []);
const getConvertedValue = (amount, fromCode, toCode) => {
    const parsedAmount = parseFloat(amount);
  
    if (isNaN(parsedAmount) || fromCode === toCode) {
      return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
    }
    const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
    const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);
    console.log('activeCurrencies isss',activeCurrencies);
    console.log('fromCurrency',fromCurrency,toCurrency);
    if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
      return '0.00';
    }
  
    const inCorporate = parsedAmount / fromCurrency.conversion_rate;
    const converted = inCorporate * toCurrency.conversion_rate;
  
    return converted.toFixed(2);
  };

  const handleFinish = async (values , saveAndNew = false,currentRelatedList) => {

    console.log('values', currentRelatedList);
    const updatedValues = generateBody(currentFieldsData, values,true);
     if(updatedValues==="error"){
        return;
      }

    const body = {
      object_name: currentChildObjectName,
      data: {
        _id: selectedRecord?._id && !selectedRecord?.isClone ? selectedRecord._id : undefined,
        ...updatedValues,
      }
    };

    console.log('body', body);
    try {
      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { 'Content-Type': 'application/json' },
        'POST',
        body
      );
      await apiService.makeCall();
      message.success(selectedRecord?._id && !selectedRecord?.isClone ? 'Record updated successfully' : 'Record created successfully');
      if (!saveAndNew) {
        if(creationView === "Modal"){
          setModalVisible(false);
        }
        else{
          setIsDrawerVisible(false);
        }
        form.resetFields();
       } else{
          form.resetFields();
          handleNewButtonClick(currentRelatedList);
          handleNewButtonClick();
          const value={
            _id: currUserId,
            Name: currUserName,
          }
          form.setFieldsValue({ User: value });
        }
      fetchRelatedRecords();
    } catch (error) {
      console.error('Error saving record:', error);
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to create record due to an unknown error';
      message.error(errorMessage);
    }
  };

  useEffect(() => {
   
  }, [currentFieldsData, objectName, currentRecordName, form]);

  const handleNewButtonClick = async (relatedList) => {
     if (security?.object_settings?.[relatedList.child_object_name]?.object_setting.create === false) {
            message.error('You dont have permission to create ');
            return;
          }
    fetchCurrentRecordDetails();
    setCurrentChildObjectName(relatedList.child_object_name);
    const fields=await fetchFieldsForChildObject(relatedList.child_object_name);
    setIsRelatedCreate(true);
    if(creationView === "Modal"){
      setCurrentRelatedList(relatedList);
      setModalVisible(true);
      const lookupfield=fields.filter((field)=>field.type==='lookup' && field.parent_object_name===objectName && field.name=== relatedList?.field_api_name);
      form.setFieldsValue({
        [lookupfield[0]?.name]: recordDetailsToSend,
      });
      
    }
    else{
      setCurrentRelatedList(relatedList);
      setIsDrawerVisible(true);
      const lookupfield=fields?.filter((field)=>field.type==='lookup' && field.parent_object_name===objectName && field.name=== relatedList?.field_api_name);
      form.setFieldsValue({
        [lookupfield[0]?.name]: recordDetailsToSend,
      });
      
    }
  };

  const handleDrawerClose = () => {
    setIsRelatedCreate(false);
    if(creationView === "Modal"){
      setModalVisible(false);
    }
    else{
      setIsDrawerVisible(false);
    }
    setCurrentFieldsData([]);
  };


  useEffect(() => {
    fetchfiles();
    fetchCurrency();
  }, [objectName, recordId])

  const fetchfiles = async () => {
    try {

      const apiService = new ApiService(
        `${BASE_URL}/get_data/${objectName}/${recordId}`,
        { 'Content-Type': 'application/json' },
        'GET',
      );
      const response = await apiService.makeCall();
      setFiles(response);

    }
    catch (error) {


    }
  }


  const handleFileUpload = async (file) => {

    const formData = new FormData();
    formData.append('file', file.file);


    try {
      const uploadService = new ApiService(`${BASE_URL}/file_upload/${objectName}/${recordId}`, {
        'Content-Type': "application/x-www-form-urlencoded"
      }, 'POST', formData);

      const response = await uploadService.makeCall();
      message.success('File uploaded succesfully');
      fetchfiles();
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to upload files due to an unknown error';
      message.error(errorMessage);
    }


  };

  const handleDownloadFile = async (fileId) => {
  
    try {
      const apiService = new ApiService(
        `${BASE_URL}/download_file/${fileId}`,
        { 'Content-Type': 'application/json' },
        'GET',
      );
  
      const response = await apiService.makeCall();
  
      if (response && response.content && response.content.$binary) {
        const { base64 } = response.content.$binary;
        const { filename } = response;
  
        const binaryData = atob(base64);
        const byteArray = new Uint8Array(binaryData.length);
  
        for (let i = 0; i < binaryData.length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
        }
  
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
  
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'downloaded_file.csv';
        document.body.appendChild(a);
        a.click();
  
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
  
      } else {
        throw new Error('Invalid file content received from the API.');
      }
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to download file due to an unknown error';
      message.error(errorMessage);
    }
  };
  

  const handleFilePreview = async (fileId) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/download_file/${fileId}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
  
      const response = await apiService.makeCall();
  
      const base64Data = response?.content?.$binary?.base64;
  
      const fileName = response?.filename;
      const fileExtension = fileName?.split('.').pop()?.toLowerCase();
  
      if (!base64Data) {
        message.error('No file data available to preview');
        return;
      }
  
      switch (fileExtension) {
        case 'pdf':
          previewPDF(base64Data);
          break;
        case 'docx':
        case 'doc':
          message.info('Preview not available for Word files. Please download to view.');
          break;
        case 'csv':
          message.info('Preview not available for CSV files. Please download to view.');
          break;
        case 'jpg':
        case 'jpeg':
        case 'png':
          previewImage(base64Data);
          break;
        default:
          message.error('Unsupported file type for preview');
          break;
      }
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to preview file due to an unknown error';
      message.error(errorMessage);
    }
  };
  
  const previewPDF = (base64Data) => {
    const binary = atob(base64Data);
    const byteArray = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      byteArray[i] = binary.charCodeAt(i);
    }
    
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };
  
  const previewImage = (base64Data) => {
    const img = new Image();
    img.src = `data:image/jpeg;base64,${base64Data}`;
    const newWindow = window.open();
    newWindow.document.body.appendChild(img);
  };


  const handleDeleteFile=async(fileId)=>{

    try {
      const apiService = new ApiService(
        `${BASE_URL}/delete_file/${fileId}`,
        { 'Content-Type': 'application/json' },
        'DELETE'
      );

      const response = await apiService.makeCall();
      message.success('File deleted succesfully');
      fetchfiles();
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to delete file due to an unknown error';
      message.error(errorMessage);
    }

  }
  
  return (
    <Spin spinning={loading}>
    <div>
    {Object.keys(groupedData).length > 0 ? (
      Object.keys(groupedData)
        .sort((a, b) => {
          const orderA = groupedData[a][0]?.order || 0;
          const orderB = groupedData[b][0]?.order || 0;
          return orderA - orderB;
        })
        .map((relatedListName) =>
        groupedData[relatedListName]
          .sort((a, b) => a.order - b.order)
          .filter(
          (relatedList) =>
            security?.object_settings?.[relatedList.child_object_name]
              ?.object_setting?.view !== false
        )
          .map((relatedList) => (
            
            <Card
              key={relatedList._id}
              title={
                <Row justify="space-between" align="middle">
                  <Col>
                    <Title level={4} style={{ margin: 0 }}>
                      {relatedListName}
                    </Title>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => handleNewButtonClick(relatedList)}
                    >
                      New
                    </Button>
                  </Col>
                </Row>
              }
              style={{ marginBottom: 12 }}
              headStyle={{ padding: "0 8px" }}   // 👈 aligns title with table
              bodyStyle={{ padding: 8 }}
            > 
              <ChildRecordTable
                fetchCurrency= {fetchCurrency}
                getConvertedValue={getConvertedValue}
                records={groupedData[relatedListName]}
                fieldsToDisplay={relatedList.fields_to_display || []}
                childRecords={childRecordsMap[relatedList._id] || []}
                fieldsData={fieldsDataMap[relatedList._id] || []}
                childObjectName={relatedList.child_object_name}
                onDelete={handleDeleteChildRecord}
                relatedListId={relatedList._id}
                currentRecordId={recordId}
                currentObjectName={objectName}
                refreshRecords={refreshRecords}
                child_object_id={relatedList.child_object_id}
                creationView={creationView}
                layout={layout}
                pagination={{
                          current: paginationState[relatedList._id]?.currentPage || 1,
                          pageSize: paginationState[relatedList._id]?.pageSize || 3,
                          total: totalRecords[relatedList._id] || 0,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100"],
                          onChange: (page, size) => {
                            fetchChildRecords(relatedList._id, recordId, relatedListName, page, size);
                            setCurrentPage(page);
                            setPageSize(size);
                          },
                          showTotal: (total, range) =>
                            `${range[0]}-${range[1]} of ${total} items`,
                      }}
              />
            </Card>
        ))
      )
    ) : null}
  
    {isAllowFile && (
      <Card
        title={
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={5} style={{ margin: 0 }}>
                Upload Files
              </Title>
            </Col>
            <Col>
              <Upload
                customRequest={handleFileUpload}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />} size="small">Upload Files</Button>
              </Upload>
            </Col>
          </Row>
        }
        bodyStyle={{ padding: 8 }}
      >
        <List
          dataSource={files}
          renderItem={(file) => (
            <List.Item
              actions={[
                <Tooltip title="Download file">
                  <Button
                    icon={<DownloadOutlined />}
                    size="small"
                    onClick={() => handleDownloadFile(file.file_id)}
                  />
                  
                </Tooltip>,
                <Tooltip title="Delete file">
                <Button
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteFile(file.file_id)}
                  size="small"
                  danger
                />
              </Tooltip>,
                

              ]}
            >
              <List.Item.Meta
        title={
          <a 
            href="#" 
            style={{
              fontWeight: '500', 
              color: '#1F5FBF', 
              textDecoration: 'none',
              borderBottom: '1px solid #1F5FBF',
              paddingBottom: '2px'
            }}
            onClick={(e) => {
              e.preventDefault();
              handleFilePreview(file.file_id);
            }}
          >
            {file.file_name}
          </a>
        }
        description=""
      />
        </List.Item>
          )}
        />
      </Card>
    )}
  
    {(isTrackFieldHistory &&
  
      <Card style = {{marginTop:"8px"}} bodyStyle={{ padding: 8 }}>
      <Row justify="space-between" align="middle">
      <Col>
        <Title level={5} style={{ margin: 0 }}>
          Field History
        </Title>
      </Col>
    </Row>
    <Divider style={{ margin: '6px 0' }} />
    <FieldHistory fields={fields}  />
    </Card>
  )}
  
    {Object.keys(groupedData).length === 0 && !isAllowFile && !isTrackFieldHistory && (
      <p>No related records found</p>
    )}
  
  {(isDrawerVisible &&  
    <CreateRecordDrawer
      visible={isDrawerVisible}
      onClose={handleDrawerClose}
      onFinish={handleFinish}
      loading={false}
      objectName={currentChildObjectName}
      fieldsData={currentFieldsData}
      form={form}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      isRelatedCreate={isRelatedCreate}
      isFieldReadOnly={isFieldReadOnly}
      isFromRelatedRecord={true}
      parent_object_name={objectName}
      parent_record_id={recordId}
      currentRelatedList={currentRelatedList}
    />
  )}

        {(modalVisible &&      
          <CreateRecordModal
            visible={modalVisible}
            onClose={handleDrawerClose}
            onFinish={handleFinish}
            loading={false}
            objectName={currentChildObjectName}
            fieldsData={currentFieldsData}
            selectedRecord={selectedRecord}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            form={form}
            // layout={layout}
            isRelatedCreate={isRelatedCreate}
            isFieldReadOnly={isFieldReadOnly}
            isFromRelatedRecord={true}
            currentRelatedList={currentRelatedList}

          />
        )}
  </div>
  
  </Spin>

  ); 
};

export default RelatedRecord;
